import { useApplicationPathContext } from '@cak-legacy/pilet-core';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { translate } from '../Locales/translator';
import { OnStepChangeScrollToHashPrefix } from './generic-rekenmodule';

export interface IOverviewEditLink {
  value: string;
  flowName: string;
  sectionName?: string;
}
export const OverviewEditLink = (props: IOverviewEditLink) => {
  const applicationPath = useApplicationPathContext();
  const urlBase = `${applicationPath}/${props.flowName}`;

  const url = props.sectionName ? `${urlBase}#${OnStepChangeScrollToHashPrefix}=${props.sectionName}` : urlBase;

  return (
    <div className="overview-edit-link">
      <span>{props.value}</span>
      <Link to={`${url}`}>{translate('Wijzigen')}</Link>
    </div>
  );
};
